import areIntlLocalesSupported from 'intl-locales-supported';
import IntlPolyfill from 'intl';

import {acceptLangs} from './localization';

/* eslint-disable global-require, import/no-dynamic-require, no-param-reassign */
export default function(obj) {
  if (obj.Intl) {
    if (!areIntlLocalesSupported(acceptLangs)) {
      Intl.NumberFormat = IntlPolyfill.NumberFormat;
      Intl.DateTimeFormat = IntlPolyfill.DateTimeFormat;
    }
  } else {
    obj.Intl = IntlPolyfill;
  }
}



// WEBPACK FOOTER //
// ../common/load-intl.js